import { Link } from "react-router-dom";
import { Zap } from "lucide-react";

export const Logo = ({ className = "", dark = false }) => (
  <Link to="/" className={`flex items-center gap-2 ${className}`} data-testid="logo-link">
    <span className="grid place-items-center w-8 h-8 rounded-[10px] bg-ho-primary text-white shadow-sm">
      <Zap className="w-[18px] h-[18px]" strokeWidth={2.5} fill="white" />
    </span>
    <span className={`font-display font-extrabold text-lg tracking-tight ${dark ? "text-white" : "text-ho-ink"}`}>
      HandsOn
    </span>
  </Link>
);
